import { call, put, takeLatest } from 'redux-saga/effects'

import { fetchFaq } from './actions'
import { FETCH_FAQ } from './constants'
import { apiFetchFaq } from './services'

function* fetchFaqWorker(action) {
  try {
    const response = yield call(apiFetchFaq, action.faqId)
    yield put(fetchFaq.success(response))
  } catch (e) {
    yield put(fetchFaq.failure(e.message))
  }
}

export default function* watcher() {
  yield takeLatest(FETCH_FAQ.REQUEST, fetchFaqWorker)
}
